module.exports = new __parcel__URL__("the-legend-of-zelda-links-awakening.5cffc249.jpg").toString();